/* global localStorage */
import { h } from 'preact';
import { useState } from 'preact/hooks';

export const fontSize = function(p) {
  const incr = p.incr || 0.1;
  const [size, setSize] = useState(-1);
  const lsname = p.lsName || 'font-size';
  const setScale = (off, ev) => {
    const s = scale(off, lsname);
    if (typeof p.onResize === 'function') p.onResize(s);
    setSize(s);
  };
  if (size < 0) setScale(0);
  return h('div', { class: 'ctl-component' },
    h('button', { onClick: setScale.bind(0, -incr) }, 'A-'),
    h('span', { style: { padding: '0 0.5em' } }, size),
    h('button', { onClick: setScale.bind(0, +incr) }, 'A+'),
  );
};

function scale(offset, lsname) {
  let gx = parseFloat(localStorage.getItem(lsname));
  if (isNaN(gx) || gx <= 0) gx = 1.0;
  offset = parseFloat(offset);
  if (!isNaN(offset)) gx += offset;
  gx = Math.round(gx * 10) / 10;
  localStorage.setItem(lsname, gx);
  document.body.style.fontSize = gx + 'rem';
  return gx;
}
